<template>
  <div>
    <!-- TODO improve colors handling -->
    <button
      v-if="!loading"
      :class="[{'btn-red': btnColor === 'red'}, {'btn btn-white': btnColor === 'blue'}, {'btn-inverted': btnColor === 'inverted'}, {'disabled': disabled, 'pointer': !disabled}]"
      class="p2 center full-height caps-text block col-12 btn-cta border-none"
      @click="action"
    >
      <b class="btn-cta-text">
        {{ getReferencelabel(reference) }}
      </b>
    </button>
    <div v-else class="full-height flex justify-center items-center">
      <div class="item-loader"> </div>
    </div>
  </div>
</template>

<script>
import { getReferencelabel } from '@/mixins/utils';

export default {
  props: {
    reference: {
      type: String,
      default: 'Continuez'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    btnColor: {
      type: String,
      default: 'red'
    },
    loading: {
      type: Boolean,
      default: false
    },
    action: Function
  },
  setup () {
    return { getReferencelabel };
  }
};
</script>
<style>

.btn-cta {
  height: 50px;
}

.btn-cta-text {
  font-size: 0.9375rem;
  font-family: DINWeb, sans-serif;
}

.btn-red {
  background-color: #e81d00;
  color: white;
}

.btn-white {
  background-color: white;
}

.btn-inverted {
  background-color: #0f1f28;
  color: white;
  font-family: DINWeb, sans-serif;
  text-decoration: none;
  text-transform: uppercase;
  transition: 0.3s ease-in all;
  cursor: pointer;
}
.btn-inverted:hover {
  background-color: transparent;
  color: #1f1f28;
  border: 1px solid #0f1f28;

}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
